export default __webpack_public_path__ + "static/media/user.cb0ddc4e.png";